import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Rekbot } from '../../models/rekbot.model';
import { RekbotsService } from '../../services/rekbots.service';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { getPolishPaginatorIntl } from '../../polish-paginator-intl';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { BehaviorSubject, finalize, Observable, of, Subject, takeUntil } from 'rxjs';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-table-rekbot-list',
  imports: [
    MatTableModule,
    CommonModule,
    MatIconModule,
    MatPaginatorModule,
    MatSortModule,
  ],
  templateUrl: './table-rekbot-list.component.html',
  styleUrl: './table-rekbot-list.component.css',
  providers: [{ provide: MatPaginatorIntl, useValue: getPolishPaginatorIntl() }]

})
export class TableRekbotListComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges{

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  private destroy$ = new Subject<void>();

  @Input() rekbots$: Observable<Rekbot[]>  = of([]);
  @Input() label = "";
  @Input() selectMode = false;
  // @Input() selecedStatus = -1;

  @Output() onChangeState = new EventEmitter<number[]>();

  sessionLabelPaginator = 'rekbotTablePaginator';
  sessionLabelSort = 'rekbotTablePage';

  userPermission: number = 0;

  clickedRows = new Set<number>();

  public rekbots: Rekbot[] = [];

  //bots: BehaviorSubject<Rekbot[]> = new BehaviorSubject<Rekbot[]>([]);

  public displayedColumns: string[] = [
    'serial_no',
    'connection',
    'status',
    'adres',
    'empty_col',
    // 'action'
  ];

  public dataSource = new MatTableDataSource<any>([]);

  constructor(
    private authService: AuthService,
    private rekbotsService: RekbotsService,
    public router: Router,

  ) { }

  ngOnInit(): void {
    // console.log('Nagłówek: ' ,this.label);
    this.userPermission = this.authService.getUser()!.role!.role_id;
    // if( this.userPermission != 0) {
      this.displayedColumns.push('action')
    // }
    
    switch(this.label){
      case 'Customer':
        this.sessionLabelPaginator = `rekbot${this.label}TablePage`;
        this.sessionLabelSort = `rekbot${this.label}TableSort`;
        break;
      case 'Installation':
        this.sessionLabelPaginator = `rekboti${this.label}TablePage`;
        this.sessionLabelSort = `rekbot${this.label}TableSort`;
        break;
      case 'Warehouse':
        this.sessionLabelPaginator = `rekboti${this.label}TablePage`;
        this.sessionLabelSort = `rekbot${this.label}TableSort`;
        break;
    }

    //this.fetchRekbots()
    /*this.bots = new BehaviorSubject<Rekbot[]>(this.rekbots$);


    this.bots.subscribe((data: Rekbot[]) => {
      console.log("bots.subscribe", data)
      this.dataSource = new MatTableDataSource<any>(data);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });*/

    /*this.bots = new BehaviorSubject<Rekbot[]>(this.rekbots || []);*/
    if(this.rekbots$) {
      this.rekbots$.subscribe((data: Rekbot[]) => {
        console.log("bots.subscribe", data)
        this.dataSource.data = data;
      });
      /*this.dataSource = new MatTableDataSource<any>(this.rekbots$.);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;*/
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      // Wczytywanie pagiatora i sorta
      const savedPage = JSON.parse(sessionStorage.getItem(this.sessionLabelPaginator) || '{}');
      if(savedPage.pageIndex != null) {
        this.paginator.pageIndex = savedPage.pageIndex;
        this.paginator.pageSize = savedPage.pageSize;
      }

      const savedSort = JSON.parse(sessionStorage.getItem(this.sessionLabelSort) || '{}');
      if (savedSort.active) {
        this.sort.active = savedSort.active;
        this.sort.direction = savedSort.direction;
      }

      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

      // Subskrypcja zamian pagiatora i sorta
      this.paginator.page
      .pipe(
        takeUntil(this.destroy$),
        // finalize(() => console.log('savePaginator'))
      )
      .subscribe(page => {
        sessionStorage.setItem(this.sessionLabelPaginator, JSON.stringify({
          pageIndex: page.pageIndex,
          pageSize: page.pageSize
        }));
      });

      this.sort.sortChange
      .pipe(
        takeUntil(this.destroy$),
        // finalize(() => console.log('saveSort'))
      )
      .subscribe((sort: Sort) => {
        sessionStorage.setItem(this.sessionLabelSort, JSON.stringify(sort));
      });
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete()
  }

  ngOnChanges(changes: SimpleChanges): void {
    const changeSelectMode = changes['selectMode'];
    if (!changeSelectMode) return;

    if (changeSelectMode.previousValue === true && changeSelectMode.currentValue === false) {
        // console.log("Zmiana rekbotów: ", Array.from(this.clickedRows));
        this.onChangeState.emit(Array.from(this.clickedRows))
      this.clickedRows.clear();
    }

    
  }

  restartApplication(rekbot: Rekbot) {
    if (confirm("Do you really want to restart application" + rekbot.serial_no)) {
      this.rekbotsService.restartApplication(rekbot)
        .subscribe({
          next: (response: any) => {
            // console.log(response);
            this.fetchRekbots();
          },
          error: error => {
            console.log("error subscribe restartApplication Rekbot ", error);
            const eRR = error.error.message

            alert("Error: " + error.error.message);
          }
        });
    }
  }

  restartApi(rekbot: Rekbot) {
    if (confirm("Do you really want to restart api " + rekbot.serial_no)) {
      this.rekbotsService.restartApi(rekbot)
        .subscribe(
          (response: any) => {
            // console.log(response);
            this.fetchRekbots();
          },
          error => {
            console.log("error subscribe restartApi Rekbot ", error);
            const eRR = error.error.message

            alert("Error: " + error.error.message);
          }
        );
    }
  }

  restartPlc(rekbot: Rekbot) {
    if (confirm("Do you really want to restart plc " + rekbot.serial_no)) {
      this.rekbotsService.restartPlc(rekbot)
        .subscribe({
          next: (response: any) => {
            // console.log(response);
            this.fetchRekbots();
          },
          error: error => {
            console.log("error subscribe restartPlc Rekbot ", error);
            const eRR = error.error.message

            alert("Error: " + error.error.message);
          }
        });
    }
  }

  restartPc(rekbot: Rekbot) {
    if (confirm("Do you really want to restart pc " + rekbot.serial_no)) {
      this.rekbotsService.restartPc(rekbot)
        .subscribe({
          next: (response: any) => {
            // console.log(response);
            this.fetchRekbots();
          },
          error: error => {
            console.log("error subscribe restartPc Rekbot ", error);
            const eRR = error.error.message

            alert("Error: " + error.error.message);
          }
        }
          /*(response: any) => {
            console.log(response);
            this.fetchRekbots();
          },
          error => {
            console.log("error subscribe restartPc Rekbot ", error);
            const eRR = error.error.message
  
            alert("Error: " + error.error.message);
          }*/
        );
    }
  }

  downloadLogs(rekbot: Rekbot) {
    // console.log("downloadLogs", rekbot)

    this.rekbotsService.downloadLogs(rekbot)
      .subscribe({
        next: (response: any) => {
          // console.log("downloadLogs", response);
          this.fetchRekbots();
        },
        error: error => {
          console.log("error subscribe downloadLogs from Rekbot ", error);
          const eRR = error.error.message

          alert("Error: " + error.error.message);
        }
      });
  }

  // deleteElement(rekbot: Rekbot) {
  //   if (confirm("Do you really want to delete " + rekbot.serial_no)) {
  //     this.rekbotsService.deleteRekbot(rekbot)
  //       .subscribe({
  //         next: (response: any) => {
  //           // console.log(response);
  //           this.fetchRekbots();
  //         },
  //         error: error => {
  //           console.log("error subscribe deleteElement ", error);
  //           const eRR = error.error.message

  //           alert("Error: " + error.error.message);
  //         }
  //       });
  //   }
  // }

  fetchRekbots(): void {
    this.rekbotsService.fetchRekbots()
      .subscribe({
        next: (response: Rekbot[]) => {

          //console.log("fetchRekbots", this.oRekbots$);

          this.rekbots = response

          console.log("FETCH REKBOTS", this.rekbots);
          
          this.dataSource.data = response;
          // this.dataSource.paginator = this.paginator;
          // this.dataSource.sort = this.sort;


        },
        error: error => {
          console.log("fetchrekbots error", error)
          if (error.status === 401) {
            this.router.navigate(['/']);
          }
        }
      });
  }

  clickRow(id: number){
    // console.log(this.selectMode);

    if(this.selectMode) {
    // console.log("nazwa rekbota",id);

    if(!this.clickedRows.has(id)){
      this.clickedRows.add(id)
    }else {
      this.clickedRows.delete(id)
    }
      
    } 
  }
}
